import React from 'react';
import PropTypes from 'prop-types';

class Page extends React.Component {
  smoothScrollUp() {
    window.scroll({ top: 0, behavior: 'smooth' });
  }

  getTitle() {
    const {location: { pathname: path }} = this.props;

    switch(path) {
      case '/':
        return 'Home';
      case '/about':
        return 'About';
      case '/projects/mini-projects':
        return 'Mini Projects';
      case '/projects/cms-clients':
        return 'CMS Clients';
      case '/random':
        return 'Random/Fun';
      case '/services':
        return 'Services';
      case '/contact':
        return 'Contact';        
      default:
        return 'Not Found'  
    }
  }

  render() {
    const title = this.getTitle();

    return (
      <div
        id={title}
        className="page"
        ref={page => {
          this.page = page;
        }}
      >
        <div className="page-title">{title}</div>
        {this.props.children}
        <footer>
          <a
            href="#"
            className="go-top"
            onClick={e => {
              e.preventDefault();
              this.smoothScrollUp();
            }}
          >
            <i className="fa fa-angle-up" />
          </a>
          {`©${new Date().getFullYear()} Hatim Hakimjee`}
        </footer>
      </div>
    );
  }
}

Page.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
};

export default Page;
